/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Pallavi Jain",
  title: "Hi all, I'm Pallavi",
  subTitle: emoji(
    "Machine Learning Engineer with 4.5+ years of experience designing and deploying ML solutions in production across Intel and high-growth startups. Proven expertise in computer vision, time-series forecasting, recommendation systems, LLMs and large-scale data pipelines. Proven track record of deploying scalable ML pipelines, achieving significant business impact, including $180K+ annual cost savings and 23% revenue growth."
    // "My passion for Data Science drives my pursuit of higher education. I've tackled advanced courses in Machine Learning, Data Mining, Natural Language Processing, and more. Currently, I'm dedicated to mastering databases and cutting-edge concepts like Generative AI and deep learning, essential skills in today's tech landscape."
    // "Data, I believe is the greatest asset. I am a passionate Machine Learning engineer with experience building scalable data and feature extraction pipelines, performing time-series analysis, building prediction and recommendation engines using a range of technologies, including Python, Clojure, Databricks, Spark, SQL, Microsoft Azure and more."
    //  experience building scalable and resilient systems using a range of technologies, including C/C++, Rust, Node.js, and more. With a focus on performance, reliability, and maintainability, I strive to deliver innovative solutions."
  ),
  resumeLink:
    // "https://drive.google.com/file/d/1pB-Cd4-u6wFuMOK5x4hrrWacqEEMC0Qn/view?usp=sharing", // Set to empty to hide the button
    // "https://drive.google.com/file/d/1JBUZhI_aiT2N5n7CKVwKeYozBwoClr5m/view?usp=sharing",
    "https://tinyurl.com/5e6waa4p",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/pjvj/",
  linkedin: "https://www.linkedin.com/in/pallavijain31/",
  gmail: "pallavijain.3196@gmail.com",
  // leetcode: "https://leetcode.com/pjvj/",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "DESIGN ANALYSE MINE VISUALIZE IMPROVE REPEAT !!!",
  skills: [
    emoji("⚡ Experienced in building scalable pipelines, including data pipelines, feature extraction pipelines, and machine learning pipelines"),
    // emoji("⚡ Adept in data engineering and enhancing database performance, involving execution plans, indexing, and normalization"),
    emoji("⚡ Adept at implementing advanced vision models, transformers architecture, LLM integration, predictive analytics, MLOps"),
    emoji("⚡ Capable of thriving in both individual and collaborative team settings, with a track record of leading cross-functional teams and contributing to intricate projects")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {skillName: "Python", },
    {skillName: "Pandas", },
    {skillName: "OpenCv", },
    {skillName: "Numpy", },
    {skillName: "Pytorch", },
    {skillName: "Streamlit", },
    {skillName: "HuggingFace", },
    {skillName: "Transformers", },
    {skillName: "CLIP", },
    {skillName: "LLMs", },
    {skillName: "AutoEncoders", },
    {skillName: "Prompt Engineering", },
    {skillName: "GANs", },
    {skillName: "A/B Testing", },
    {skillName: "FastAPI", },
    {skillName: "PySpark", },
    {skillName: "Databricks", },
    {skillName: "SQL", },
    {skillName: "C++", },
    {skillName: "Tensorflow", },
    {skillName: "PostgreSQL", },
    {skillName: "RedisDB", },
    {skillName: "MongoDB", },
    {skillName: "Azure", },
    {skillName: "AWS", },
    {skillName: "Docker", },
    {skillName: "Weka", },
    {skillName: "PowerBI", },
    {skillName: "Jira", },
    {skillName: "ETL", },
    {skillName: "Linux", },
    {skillName: "Git", },
    {skillName: "Jenkins", },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Illinois Urbana Champaign",
      logo: require("./assets/images/uiuc_logo.png"),
      subHeader: "Master in Computer Science",
      duration: "August 2022 - December 2023",
      desc: "Relevant Courses: Data Mining, Applied Machine Learning, Natural Language Processing, Signal Processing for Machine Learning, Computational Photography, Distributed Systems",
      descBullets: [
        "Teaching Assistant for Text Mining course- researched NLP and Text Mining papers; created data-preprocessing & ML programming assignments;\
         conducted text mining lab sessions; and mentored students with machine learning projects.",
        "Contributed to ongoing research as Graduate Student Researcher under the guidance of Professor Mary Pietrowiz in psychometrica and ML project- \
         Exploring speech classification models for detecting depression and anxiety; creating a data-preprocessing pipeline to analyze linguistic psychology.",
        "Been a part of Advanced Creativity class that promotes innovation and entrepreneurial spirit.",
        "Member of ACM society, Women in Engineering."
      ]
    },
    {
      schoolName: "Birla Institute of Technology",
      logo: require("./assets/images/bit.png"),
      subHeader: "Bachelor of Engineering in Computer Science & Engineering",
      duration: "August 2015 - May 2019",
      desc: "Relevant Courses: Data Science, Probability Statistics and Numerical Techniques, Artificial Intelligence, Data Structures and Algorithms, Operating Systems, DBMS",
      descBullets: [
        "Certificate of Academic Excellence, 2019, BIT Mesra: Awarded for being in the top 3 students in CS department.",
        "Bagged 1st prize in the Technical project presentation 2018, for building the Psychometric Analysis Tool using Data Science techniques for interviewers and psychologists to help determine interviewee’s psychological characteristics.",
        "With a team of 4, won at CodeAsylums Winter Hackathon 2017, by creating a website to help users code.",
        "Won Robotics events at Technical fest, 2016, Edge Avoider and Obstacle Avoider for building and racing the autonomous bots using microcontrollers and embedded-C.",
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Coding",
      progressPercentage: "40%"
    },
    {
      Stack: "ML System Design and Architecture",
      progressPercentage: "20%"
    },
    {
      Stack: "Data Science and Analytics", //Insert stack or technology you have experience in
      progressPercentage: "20%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Communication and Collaboration",
      progressPercentage: "20%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
     {
      role: "Engineering Project Analyst - Machine Learning Engineer",
      company: "Intel Corporation",
      companylogo: require("./assets/images/intellogo1.png"),
      date: "Feb 2024 – Present",
      desc: "Transforming semiconductor quality assurance through AI and computer vision-driven automation, reducing manual inspection overhead while improving defect detection accuracy and manufacturing yield optimization",
      descBullets: [
        "Working on the POC development for computer vision automatic Defect CLassification ADC applications",
        "Adapting Contrastive Language-Image Pretraining for SEM imagery analysis in defect isolation from complex semiconductor backgrounds using text-prompt guidance and few-shot learning", 
        "Implementing ViT architecture for mixed-type wafer defect classification", 
        "Architected and deployed production-grade image processing algorithms for automated semiconductor wafer defect detection across multi-stage manufacturing processes, building comprehensive defect datasets for model validation and continuous improvement",
        "Developed sophisticated exponential weighted moving average models for defect threshold optimization, significantly reducing manufacturing risk propagation",
        "Built an end-to-end lot tracking system for the foundry's new product introduction, enabling real-time manufacturing visibility and data-driven process optimization"
        ],
      technologies: ["Python", "Deep Learning", "Computer Vision", "Machine Learning", "Predictive Analytics", "Data Visualization"]
    },
    {
      role: "Graduate Research Assistant - Machine Learning Engineer",
      company: "University of Illinois, Urbana Champaign",
      companylogo: require("./assets/images/uiuc_logo.png"),
      date: "Aug 2023 – Dec 2023",
      desc: "Worked on Influence Campaign Awareness and Sensemaking (INCAS) project for DARPA with Professor Tarek Abdelzaher, UIUC",
      descBullets: [
        "Explored influence detection in language graphs and prompt engineering for summarization.",
        "Conducted research on influence detection in linguistic and social graphs, exploring adversarial narratives, semantic drift, and coordinated campaign behaviors.",
        "Integrated state-of-the-art LLMs, graph ML, and summarization techniques for explainable influence mapping.",
        "Tracked the rise and fall of sub-narratives using LLM-assisted event extraction + dynamic topic modeling.",
        "Employed GAT/GraphSAGE models over language similarity graphs to detect clusters of coordinated linguistic behavior.",
        ],
      technologies: ["Python", "Deep Learning", "Machine Learning", "NLP", "LLMs", "Graph Networks", "BERT", "Prompt Engineering", "Statistical Data Analysis"]
    },
    {
      role: "Graduate Process Engineer Intern - Data Science",
      company: "Intel Corporation",
      companylogo: require("./assets/images/intellogo1.png"),
      date: "May 2023 – August 2023",
      desc: "Special Recognition for outstanding performance and delivery",
      descBullets: [
        "Performed reliability analysis of tools using tool failure data and predicted an efficient downtime schedule for maintenance activities.",
        "Automated identification of missing information in tools specifications, detecting 50 crucial omissions, resulting in a 10% increase in operational efficiency and substantial monthly cost savings",
        "Developed a robust ML pipeline to forecast preventive maintenance windows using tool failure data. Implemented automated tool selection process resulting in a 4.7% reduction in maintenance expenses.",
        "Leveraged tree-based classifiers to perform Root Cause Analysis (RCA) on tool failure data, uncovering process subsystem bottlenecks and achieving a significant reduction in downtime by 15%.",
      ],
      technologies: ["Python", "SQL", "Time-Series Forecasting","Machine Learning", "Microsoft Azure", "Data Mining", "Predictive Analysis", "Data Visualization", "PowerBI"]
    },

    // {
    //   role: "Graduate Research Assistant - Machine Learning Engineer",
    //   company: "University of Illinois, Urbana Champaign",
    //   companylogo: require("./assets/images/uiuc_logo.png"),
    //   date: "Jan 2023 – May 2023",
    //   desc: "Psychometrics- linguistic psychology and speech perception with Professor Mary Pietrowicz, UIUC",
    //   descBullets: [
    //     "Worked on acoustic analysis of therapy audio data to detect and classify depression levels.",
    //     "Used deep learning models to learn patterns in human speech to distinguish different expressions and behaviors under psychological test frames.",
    //     "Developed a data-preprocessing pipeline to analyze linguistic psychology.",
    //     "Conducted ML model experiments for the research paper publication."
    //     ],
    //   technologies: ["Python", "Deep Learning", "Audio Signal Processing", "Machine Learning", "Acoustic Analysis"]
    // },
    
    {
      role: "Machine Learning Engineer",
      company: "Swym Corporation",
      companylogo: require("./assets/images/swym-logo.png"),
      date: "Jun 2019 – Jul 2022 (3 years, 1 month)",
      desc: "Built Machine Learning backbone from scratch and Data Platform for Business Intelligence",
      bullet_format: "heading",
      descBullets: [
        {
          heading: "Data Science and Machine Learning",
          bullets: [
            "MLOps Infrastructure: Led Azure ML adoption with Databricks and PySpark integration, achieving 25x system scalability",
            "Recommendation Systems: Designed and deployed a recommendation engine, increasing merchant sales by 7%",
            "Built ResNet/MobileNet-based image feature extraction for visual similarity matching",
            "Implemented the SAR collaborative filtering algorithm, addressing cold-start problems",
            "Enhanced system with two-tower embedding model using PySpark and NLP, improving top-k recommendations by 25%",
            "Utilized a supervised tree-based learning algorithm to develop a User Engagement Prediction Model, enabling targeted campaigns and improved purchase facilitation.",
            "Deployed ML models & performed hyperparameter tuning to obtain best performance & diagnosis for time series analysis.",
            "Enhanced the efficiency of product out-of-stock analysis and KPI monitoring for the ML team by creating interactive dashboards utilizing Dash, streamlit, and matplotlib."]
        },
        {
          heading: "Distributed Systems and Data Engineering",
          bullets: [
            "Spearheaded a data pipeline infrastructure (ETL) for data structuring and data movement to different data warehouses and databases- MongoDB, cosmos DB, blob storage, and logs depending upon the query frequency and data velocity.",
            "Enhanced efficiency of business intelligence layer, redesigning database schema and scripts to refresh derived and summary tables & views, ensuring real-time data availability for 30K merchant dashboards using ragtime-migrations & distributed PostgreSQL.",
            "Led the design and implementation of data migration, seamlessly transferring transactional data from MSSQLServer to Citus (distributed Postgres) warehouse while maintaining reliability and facilitating concurrent analytics.",
            "Implemented complete Elastic Stack of elasticsearch, kibana & logstash to enable full-text search with an HTTP web interface.",
            // "Devised map-reduce & segmentation algorithm to parallelize data processing, improving response time by more than 20%.",
            // "Provisioned scalable & distributed backend, and A/B Testing for various ML features enabling product adaptability.",
          ]
        },
        {
          heading: "Backend Development and Automation",
          bullets: [
            "Provisioned scalable & distributed backend, and A/B Testing for various recommendations features enabling product adaptability.",
            "Devised map-reduce & segmentation algorithm to parallelize data processing, improving response time by more than 20%.",
          ]
        },
        {
          heading: "Impact",
          bullets: [
            "Transformed startup data capabilities to enterprise-scale, driving revenue growth and customer acquisition through ML innovation",
            "Revenue Growth: Turned cross-merchant insights into a feature boosting enterprise conversions and recurring revenue by 23%",
          ]
        }
      ],
      technologies: ["Python", "PySpark", "SQL", "Machine Learning", "ResNet / MobileNet", "Computer Vision", "NLP", "Recommendations Systems", "Time Series Forecasting", "Bash Script", "Microsoft Azure", "Weka", "Clojure", "Databricks", "Makefile", "ETL", "Postgres", "MongoBD", "Redis", "ElasticSearch", "Azure Data Factory"]
    },
    
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};


const bigProjects = {
  title: "Projects",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/deep_transform.png"),
      projectName: "Decoder Transformer Language Model",
      bullets: [
        "Developed a character-level, Decoder Transformer Language Model that generates Shakespeare-like text being trained on Shakespeare’s work dataset",
        "Implemented Self-Attention mechanism from the paper 'Attention is all you need'",
        "Trained the model with 10.78 Million parameters"
      ],
      technologies: ["Language Models","Decoder Transformer Model","Self-Attention mechanism","Python","Colab","PyTorch","Generative AI","Hyperparameter Tuning","NLP"],
      github: "https://github.com/pjvj/TextGeneration_LanguageModel",
      bullets_height: 56
    },
    {
      image: require("./assets/images/cbow-nn.png"),
      projectName: "CBOW Feedforward Neural Network",
      bullets: [
        "Created word embeddings using the continuous-bag-of-words (CBOW) method",
        "Trained a feed-forward neural network that takes in a context vector and predicts the word that completes the context",
      ],
      technologies: ["Language Models", "Continuous Bag of Words", "Feed forward Neural Networks", "Word embeddings","PyTorch","Python","Colab","PyTorch","Generative AI","Hyperparameter Tuning","NLP"],
      github: "https://github.com/pjvj/CBOW_Feedforward_Neural_Network",
      bullets_height: 56
    },
    {
      image: require("./assets/images/signal-processing-algos.png"),
      projectName: "Signal Processing Algorithms",
      bullets: [
        "Developed PCA, ICA, and NMF algorithms to process audio and images by applying FFT for spectral analysis",
      ],
      technologies: ["Language Models", "Continuous Bag of Words", "Feed forward Neural Networks", "Word embeddings","PyTorch","Python","Colab","PyTorch","Generative AI","Hyperparameter Tuning","NLP"],
      github: "https://github.com/pjvj/Signal_Processing_Algorithms",
      bullets_height: 56
    },
    {
      image: require("./assets/images/stride-system.png"),
      projectName: "Decentralized P2P RideShare Distributed System",
      bullets: [
        "Built a decentralized P2P distributed system for ride sharing application using clustering and bidding mechanisms aimed at improving reliability and removing privacy concerns in the system.",
        "Implemented a distributed k-means-clustering algorithm for clustering client nodes (riders and drivers) into smaller clusters.",
        "Designed a bidding algorithm for near optimal matching of riders and drivers based on minimum driver’s cost plus the distance from the rider’s start to their desired destination."],
      technologies: ["Golang", "Clustering", "Remote Procedure Calls", "Distributed Systems"],
      github: "https://github.com/pjvj/ridehost",
      report: "https://drive.google.com/file/d/1hbGf1Mo5r8jSmbrbvGsYF-92ZWwXKM0D/view?usp=sharing",
      presentation: "https://drive.google.com/file/d/1KkbAzlw4DPSzW7d5S9Sc19HtyNNVC98H/view?usp=sharing",
      bullets_height: 56
    },
    {
      image: require("./assets/images/number-plate-recognition.png"),
      projectName: "License Plate Detection and Recognition",
      bullets: [
        "Created an automatic license plate detection pipeline employing transfer learning by fine-tuning some object-detection models.",
        "Fine-tuned YOLOv5 model and Inception-ResNet-v2 model with License Plate Dataset.",
        "Implemented optical character recognition using easyocr library.",
        "Automated the pipeline for real-time detetction of license plate in a video stream."
      ],
      report: "https://github.com/pjvj/Automatic-License-Plate-Detection-and-Recognition/blob/main/Project_Report.pdf",
      technologies: ["Python", "Google-Colaboratory", "Machine Learning", "Object Detection", "Optical Character Recognition", "Computational Photography", "Computer Vision"],
      github: "https://github.com/pjvj/Automatic-License-Plate-Detection-and-Recognition",
      bullets_height: 56
    },
    {
      image: require("./assets/images/psychometric-analysis.png"),
      projectName: "Psychometric Analysis Tool",
      bullets: [
        "Designed and developed machine learning-based tool for interviewers and psychologists to help determine patients' and interviewee’s psychological characteristics.",
        "Implemented detection and analysis of facial expressions, speech and opinions (in text and speech) collected from different test phases that a person goes through in the tool.",
        "Modeled a Convolutional Neural Network (CNN) for Facial Emotion Recognition of the snapshots taken during test phases.",
        "Performed Speech Emotion Recognition using LSTM model on the speech data collected as answers to questions from a speech test phase.",
        "Modeled an Artificial Neural Network (ANN) for Sentiment Analysis of text collected as answers to image description and perception test phase.",
        "Created an Adaptive chatbot in the form a test that does Similarity Analysis of text and adapts next question according to a set difficulty.",
        "Designed a website with 4 test phases and provision for setting up the test by the psychologists or interviewers."],
      report: "https://drive.google.com/file/d/1N0ePtONaTA8K5s62JWuBD9uipU6xIQ1_/view?usp=sharing",
      technologies: ["Python", "Machine Learning", "Image Processing", "CNN", "LSTM", "Sentiment Analysis", "Facial Emotion Recognition", "Speech Emotion Recognition", "Adaptive Chatbot", "Similarity Analysis", "Natural language Processing", "Bash Script", "SQL", "Reactjs", "Nodejs"],
      presentation: "https://drive.google.com/file/d/1WwUtVIAP_jhNSevh0FFEk85UYN6nX8JU/view?usp=sharing",
      github: "https://github.com/pjvj/PsychometricAnalysisWebtool",
      bullets_height: 56,
      bullet_overflow: true,
      skills_height: 56
    },
    {
      image: require("./assets/images/image-based-lighting.png"),
      projectName: "Image Based Lighting",
      bullets: [
        "Produced High Dynamic Range (HDR) images using weighted and calibrated merging of Low Dynammic Range (LDR) images.",
        "Rendered synthetic objects on the HDR images using their environment map."],
      technologies: ["Python", "Computational Photography", "Computer Vision", "Image Processing"],
      bullets_height: 56
    },
    {
      image: require("./assets/images/texture transfer.png"),
      projectName: "Image Quilting and Texture Transfer",
      bullets: [
        "Used Sum of Squared Differences (SSD) cost of overlapping regions and minimum cost seam-finding method to generate repeated texture.",
        "Created a texture-transferred image guided by a target correspondence image."],
      technologies: ["Python", "Computational Photography", "Computer Vision", "Image Processing"],
      bullets_height: 56,
      github:"https://github.com/pjvj/ImageQuilting_TextureTransfer",
    },
    {
      image: require("./assets/images/sentiment-analysis.png"),
      projectName: "Sentiment Analysis of Amazon Product Reviews",
      bullets: [
        "Classified reviewers into promoters, detractors and passives using Natural Language Processing.",
        "Extracted features using self-devised text vectorization formula adapting from TF-IDF formula.",
        "Trained an Artificial Neural Network for classification of reviews into positive, negative and neutral."],
      // report: "https://drive.google.com/file/d/170LEbWbp2tkPLOKEHumtLh9Gblm7dd6c/view?usp=sharing",
      technologies: ["Python", "Machine Learning", "Sentiment Analysis", "Natural Language Processing"],
      github: "https://github.com/pjvj/SentimentAnalysis",
      poster: "https://drive.google.com/file/d/1wR8mmtwIj3JQxxDK0e122KZLJiDFJVLz/view?usp=sharing",
      bullets_height: 56,
      skills_height: 56
    },
    {
      image: require("./assets/images/dictionary.png"),
      projectName: "Self Learning Dictionary",
      bullets: [
        "Developed self-learning dictionary using hashing in python to return the meaning of a searched word.",
        "Extended functionality to provide suggestions for a misspelled word & remember the choice made by user to learn for better suggestions."],
      technologies: ["Python", "Hashing", "Minimum Edit Distance", "Dynamic Programming"],
      github: "https://github.com/pjvj/Dictionary",
      bullets_height: 56
    }

  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",
  achievementsCards: [
    {
      title: "Graduate Research Assistant- Machine Learning",
      subtitle: "Working on Influence Campaign Awareness and Sensemaking (INCAS) project for DARPA utilizing and polishing my skills in Text Mining, Language Models, NLP, ML, etc.",
      image: require("./assets/images/INCAS.jpg"),
      imageAlt: "Google Assistant Action Logo",
    },
    {
      title: "Special Recognition Award, 2023, Intel Corporation",
      subtitle: "Awarded with special recognition for outstanding performance and delivery during the Summer internship",
      image: require("./assets/images/Intel-Logo2.png"),
      imageAlt: "Google Assistant Action Logo",
    },
    {
      title: "Special Recognition Award, 2021 & 2022, Swym Corporation",
      subtitle: "Awarded a cash prize for building the Machine Learning backbone for the company singlehandedly as a Machine Learning Engineer. Got 40% appraisal for 2 consecutive years for my performance and making an impact in Company's revenue",
      image: require("./assets/images/datascience-swym.jpeg"),
      imageAlt: "Google Assistant Action Logo",
    },
    {
      title: "Certificate of Academic Excellence, 2019, BIT Mesra",
      subtitle: "Awarded for being in the top 3 students in the Computer Science department",
      image: require("./assets/images/academic-excellence.jpeg"),
      imageAlt: "Google Assistant Action Logo",  
    },
    {
      title: "Graduate Research Assistant- Psychometrics and Machine Learning",
      subtitle: "Exploring speech classification models for detecting depression and anxiety; creating a data-preprocessing pipeline to analyze linguistic psychology",
      image: require("./assets/images/MLpsycho.jpeg"),
      imageAlt: "Google Assistant Action Logo",
    },
    {
      title: "Graduate Teaching Assistant- Text Mining",
      subtitle: "Researched NLP and Text Mining papers; created data-preprocessing & ML programming assignments; conducted text mining lab sessions; and mentored students with machine learning projects",
      image: require("./assets/images/text-mining.jpeg"),
      imageAlt: "Google Assistant Action Logo",
    },
    {
      title: "Certification (Udemy) - Statistics for Data Science and Business Analysis",
      subtitle: "Completed the Statistics for Data Science and Business Analysis course revising my concepts",
      image: require("./assets/images/stats-for-ds-certi.jpeg"),
      imageAlt: "Google Assistant Action Logo",
    },
    {
      title: "Certification (LinkedIn) - Data Science Foundations: Data Mining in Python",
      subtitle: "Finished Data Science Foundations: Data Mining in Python on linkedin learning",
      image: require("./assets/images/dsf-dmp.jpeg"),
      imageAlt: "Google Assistant Action Logo",
    },
    {
      title: "Certification (LinkedIn) - Advanced SQL for Data Science: Time Series",
      subtitle: "Finished Advanced SQL for Data Science: Time Series on linkedin learning",
      image: require("./assets/images/adv-sql-for-ds-time-series.jpeg"),
      imageAlt: "Google Assistant Action Logo",
    },
    {
      title: "Certification (LinkedIn) - Data Science Foundations: Data Engineering",
      subtitle: "Finished Data Science Foundations: Data Engineering on linkedin learning",
      image: require("./assets/images/dsf-de.jpeg"),
      imageAlt: "Google Assistant Action Logo",
    },
    {
      title: "Mentor, workshop on ML with Python",
      subtitle: "Conducted workshops for college students fostering python programming language concepts and ML projects in sentiment analysis, natural language processing, text mining, text & image classification",
      image: require("./assets/images/mentoring.jpeg"),
      imageAlt: "Google Assistant Action Logo",
      
    },
    {
      title: "Class Representative of Computer Science Department, 2015-2019, BIT Mesra",
      subtitle: "Organized mock-tests, interview-drills for placement preparations. Taught concepts like OOPs, Data Structures & Algorithms, STL(C++), ML & Data Science to fellow staudents and juniors",
      image: require("./assets/images/computer-science-cr.png"),
      imageAlt: "Google Assistant Action Logo",
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "pallavijain.3196@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
